/** @jsxImportSource @emotion/react */
import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { accessAPI, useEstetica } from "../../shared";
import { Formulario } from "../../shared";
import logoVerticalBlanco from "../../images/logoVerticalBlanco.png";
import danger from "../../images/danger.png";
import { Boton } from "../../shared";

import { Toast } from "primereact/toast";
import { Card } from "primereact/card";

export default function Login() {
  const estetica = useEstetica();
  const [loginFormLoader, setLoginFormLoader] = useState(false);

  const navigate = useNavigate();

  const toast = useRef(null);

  // Configuración del formulario de login
  const loginFormConfig = {
    secciones: [
      {
        campos: [
          {
            nombre: "username",
            tipoitemformularioid: 2,
            etiqueta: "Email",
            requerido: true
          },
          {
            nombre: "password",
            tipoitemformularioid: 3,
            etiqueta: "Contraseña",
            requerido: true
          }
        ]
      }
    ],
    botones: [
      {
        etiqueta: "Ingresar",
        validar: true,
        callback: loginFormSubmit
      }
    ]
  };

  // Submit de formulario de login
  function loginFormSubmit(contenidoCampos) {
    setLoginFormLoader(true);
    accessAPI(
      "POST",
      "oauth",
      contenidoCampos,
      (respuesta) => {
        if (respuesta.url) {
          window.location.href = respuesta.url;
        } else {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "Ocurrió un error, intente nuevamente más tarde.",
            sticky: true
          });
          setLoginFormLoader(false);
        }
      },
      (response) => {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail:
            response[0]?.msg ||
            "Ocurrió un error, intente nuevamente más tarde.",
          sticky: true
        });
        setLoginFormLoader(false);
      }
    );
  }

  return (
    <main css={{ height: "calc(100vh - var(--alturaFooter))" }}>
      <Toast ref={toast} position="top-center" />
      <div
        css={{
          paddingTop: "50px",
          marginBottom: "30px",
          width: "100%",
          marginLeft: "auto",
          marginRight: "auto"
        }}
      >
        <img
          css={{
            width: "150px",
            marginLeft: "auto",
            marginRight: "auto",
            display: "block"
          }}
          // El logo en blanco del organismo; si no cargó uno, el de la
          // plataforma.
          src={estetica?.logos?.blanco || logoVerticalBlanco}
          alt={estetica?.nombre || "logo"}
        />
      </div>
      <Card
        css={{
          width: "400px",
          marginLeft: "auto",
          marginRight: "auto",
          padding: "30px 0px"
        }}
      >
        {process.env.REACT_APP_MANTENIMIENTO === "true" && (
          <div className="recuadroContent flexContainer vertical">
            <img src={danger} alt="logo" />
            <div className="centrado margenAbajo rojo negrita">
              Morfeo está en mantenimiento, por favor intente ingresar en unos
              minutos.
            </div>
          </div>
        )}
        {process.env.REACT_APP_MANTENIMIENTO !== "true" && (
          <div
            css={{
              padding: "0px 50px"
            }}
          >
            <div
              css={{
                marginLeft: "auto",
                marginRight: "auto",
                textAlign: "center",
                marginBottom: "30px",
                color: "var(--principal)",
                fontSize: "1.6em"
              }}
            >
              Gestiona tus certificados
            </div>
            <Formulario
              config={loginFormConfig}
              loader={loginFormLoader}
              formularioEnCuerpo
            />
          </div>
        )}
      </Card>
      {process.env.REACT_APP_MANTENIMIENTO !== "true" && (
        <div
          css={{
            width: "400px",
            marginLeft: "auto",
            marginRight: "auto",
            display: "flex",
            justifyContent: "space-between"
          }}
        >
          <Boton
            callback={() => {
              navigate("/registro");
            }}
            texto
            blanco
          >
            Registrar empresa
          </Boton>
          <Boton
            texto
            blanco
            callback={() => {
              navigate("/solicitudCambioPassword");
            }}
          >
            Olvidé mi contraseña
          </Boton>
        </div>
      )}
    </main>
  );
}
